export default "__VITE_ASSET__DLCwFR6L__"